import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { StoreState } from '../../../../redux/reducers/store.types';
import { Dispatch } from '../../../../redux/redux.types';
import {
  TeamMemberEditFormComponent,
  TeamMemberEditFormOwnProps,
  TeamMemberEditFormProps,
} from '../../../team/team-member-modal/team-member-edit-form/team-member-edit-form';
import { openProjectOverviewMembersDeleteMemberModalFromEditMemberModal } from '../project-overview-members.actions';
import {
  getProjectOverviewMembersEditingMemberAvatarUrl,
  getProjectOverviewMembersEditingMemberEmail,
  getProjectOverviewMembersEditingName,
  getProjectOverviewMembersEditingSecurityGroups,
} from '../project-overview-members.selectors-ui';

export const PROJECT_OVERVIEW_MEMBERS_EDIT_MEMBER_FORM =
  'projectOverviewMembersEditMemberForm';

export const ProjectOverviewMembersEditMemberForm = compose<
  TeamMemberEditFormProps,
  TeamMemberEditFormOwnProps
>(
  connect(
    (state: StoreState) => ({
      teamMemberAvatarUrl:
        getProjectOverviewMembersEditingMemberAvatarUrl(state),
      teamMemberEmail: getProjectOverviewMembersEditingMemberEmail(state),
      teamMemberName: getProjectOverviewMembersEditingName(state),
      initialValues: {
        securityGroups: getProjectOverviewMembersEditingSecurityGroups(state),
      },
    }),
    (dispatch: Dispatch) => ({
      openTeamMemberDeleteModal: () =>
        dispatch(
          openProjectOverviewMembersDeleteMemberModalFromEditMemberModal(),
        ),
    }),
  ),
  injectIntl,
)(TeamMemberEditFormComponent);
